import { ErrorHandler, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AirportNavaid } from '../models/airport-navaid.model';

@Injectable()
export class NavaidService {

  constructor(private _http: HttpClient,
              private _errorHandler: ErrorHandler) { }
  /**
   * updates specified entity via api
   * @param {AirportNavaid} navaid
   * @return {Promise<any>}
   */
  putNavaid(navaid: AirportNavaid): Promise<any> {
    const URL = `${environment.airportsApiUrl}/navaid/${navaid.navaidId}`;
    try {
      const BODY = this._getNavaidJSON(navaid);
      return this._http.put(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * adds specified entity via api
   * @param {AirportNavaid} navaid
   * @return {Promise<any>}
   */
  postNavaid(navaid: AirportNavaid): Promise<any> {
    const URL = `${environment.airportsApiUrl}/navaid/`;
    try {
      const BODY = this._getNavaidJSON(navaid);
      return this._http.post(URL, BODY).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * deletes specified entity via api
   * @param {number} navaidID
   * @return {Promise<any>}
   */
  deleteNavaid(navaidID: number): Promise<any> {
    const URL = `${environment.airportsApiUrl}/navaid/${navaidID}`;
    try {
      return this._http.delete(URL).toPromise();
    } catch (e) {
      this._errorHandler.handleError(e);
      throw e;
    }
  }

  /**
   * converts entity to json obj
   * @param {AirportNavaid} navaid
   * @return {any}
   * @private
   */
  _getNavaidJSON (navaid: AirportNavaid): any {
    return {
      navaidId: navaid.navaidId,
      identifier: navaid.identifier,
      name: navaid.name,
      type: AirportNavaid.formatNavaidType(navaid.type),
      frequency: navaid.frequency,
      distance: navaid.distance,
      radial: navaid.radial,
      location: {
        latitude: navaid.location.lat,
        longitude: navaid.location.lon
      },
      sourceId: 10,
      magvar: navaid.magvar,
      elevation: navaid.elevation,
      city: navaid.city,
      state: navaid.state,
      country: navaid.country,
      status: navaid.status
    };
  }
}
